var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('roskilde-button',{on:{"click":_vm.openPopupChoices}},[_vm._v("Open questions")]),_c('roskilde-button',{on:{"click":_vm.openPopupInfo}},[_vm._v("Open info")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }